import { render, staticRenderFns } from "./broadcast_add.vue?vue&type=template&id=03b4f887&"
import script from "./broadcast_add.vue?vue&type=script&lang=ts&"
export * from "./broadcast_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports